import React from 'react'
import { IOptionString } from '../../../../interfaces/common/form/option';
import { RequiredStar, SelectContainer, StyledSelect } from "./SelectString.styled";
import { Label } from '../label/Label';

interface IProps {
  selectValue: string | number | null;
  elementName: string;
  // TODO: delete this prop and replace it with handleChange every functions in the code
  setValue?: (value: string) => void;
  handleChange?: (e: React.ChangeEvent<any>) => void;
  optionsArray: IOptionString[] | string[];
  defaultValue?: string;
  label?: string;
  isRequired?: boolean;
  isError?: boolean;
  disabled?: boolean;
  color?: string;
  colorLabel?: string;
  borderColor?: string;
  background?: string;
  onBlur?: (event: React.FocusEvent<HTMLSelectElement>) => void;
}

export const SelectString: React.FC<IProps> = ({
                                                 label,
                                                 isError,
                                                 isRequired,
                                                 selectValue,
                                                 elementName,
                                                 defaultValue,
                                                 setValue,
                                                 handleChange,
                                                 optionsArray,
                                                 color,
                                                 colorLabel,
                                                 borderColor,
                                                 background,
                                                 onBlur,
                                                 disabled
                                               }) => {
  return (
    <SelectContainer>
      {label && (
        <Label color={colorLabel} size={'small'} label={<>
          {label}
          {isRequired && <RequiredStar color={colorLabel}>*</RequiredStar>}
        </>}/>
      )}
      <StyledSelect
        name={elementName}
        value={selectValue || ""}
        onBlur={onBlur}
        disabled={disabled}
        onChange={(e) => {
          setValue && setValue(e.target.value);
          handleChange && handleChange(e);
        }}
        id={elementName}
        $border={borderColor}
        $background={background}
        $color={color}
        $isError={isError || false}
      >
        <option value={''}>{defaultValue}</option>
        {optionsArray?.map((option, index) => (
          <option
            key={index}
            value={typeof option === "object" ? option.id : option}
          >
            {typeof option === "object" ? option.title : option}
          </option>
        ))}
      </StyledSelect>
    </SelectContainer>
  )
}
